import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.test.js";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

var e_1, _a, e_2, _b;

import { assert } from "./assert";
import { Emoji } from "@/assets/sprites/emoji";
import { Icon } from "@/assets/sprites/icon";
import { biz_emoji_map, SIMPLE_EMOJI_KEYS_WITH_ORDER } from "./emojiPathMap";
import "@/common/emoji_retina_icons.scss";
var EMOJI_PREFIX = "emoji--";
var simple_emoji_classes = Object.values(Emoji).filter(function (i) {
  return i.startsWith(EMOJI_PREFIX);
});
var simpleEmojiClassesWithOrder = SIMPLE_EMOJI_KEYS_WITH_ORDER.map(function (e) {
  return Emoji[e];
});
assert(simple_emoji_classes.length === simpleEmojiClassesWithOrder.length, "emoji classes count not equal to sorted emoji arr len");
var BIZ_EMOJI_PREFIX = "icon--biz-";
var biz_emoji_classes = Object.values(Icon).filter(function (i) {
  return i.startsWith(BIZ_EMOJI_PREFIX);
});
export var simpleEmojis = {};
var separator = "\u2004";

try {
  for (var simpleEmojiClassesWithOrder_1 = __values(simpleEmojiClassesWithOrder), simpleEmojiClassesWithOrder_1_1 = simpleEmojiClassesWithOrder_1.next(); !simpleEmojiClassesWithOrder_1_1.done; simpleEmojiClassesWithOrder_1_1 = simpleEmojiClassesWithOrder_1.next()) {
    var emoji_class = simpleEmojiClassesWithOrder_1_1.value;
    var name = emoji_class.replace(EMOJI_PREFIX, ""); //angry

    var code = ("" + separator + name + separator).replace(/-/g, "_");
    simpleEmojis[code] = {
      code: code,
      name: name,
      iconClass: emoji_class
    };
  }
} catch (e_1_1) {
  e_1 = {
    error: e_1_1
  };
} finally {
  try {
    if (simpleEmojiClassesWithOrder_1_1 && !simpleEmojiClassesWithOrder_1_1.done && (_a = simpleEmojiClassesWithOrder_1["return"])) _a.call(simpleEmojiClassesWithOrder_1);
  } finally {
    if (e_1) throw e_1.error;
  }
}

export var businessEmojis = {};

try {
  for (var biz_emoji_classes_1 = __values(biz_emoji_classes), biz_emoji_classes_1_1 = biz_emoji_classes_1.next(); !biz_emoji_classes_1_1.done; biz_emoji_classes_1_1 = biz_emoji_classes_1.next()) {
    var emoji_class = biz_emoji_classes_1_1.value;
    var name = emoji_class.replace(BIZ_EMOJI_PREFIX, ""); //e.g. business-1

    var code = name.replace("-", "_");
    var emoji_path = biz_emoji_map[code];
    assert(emoji_path, "failed to find emoji_path for code: " + emoji_class);
    businessEmojis[code] = {
      code: code,
      name: emoji_class,
      imgPath: emoji_path,
      iconClass: emoji_class
    };
  }
} catch (e_2_1) {
  e_2 = {
    error: e_2_1
  };
} finally {
  try {
    if (biz_emoji_classes_1_1 && !biz_emoji_classes_1_1.done && (_b = biz_emoji_classes_1["return"])) _b.call(biz_emoji_classes_1);
  } finally {
    if (e_2) throw e_2.error;
  }
}

export function convertTextToEmojiHtml(msg) {
  var reg = /\u2004[\w-_]+\u2004/g;

  if (reg.test(msg)) {
    msg = msg.replace(reg, function (str) {
      var emoji = simpleEmojis[str];

      if (!emoji) {
        console.log("no emoji for", str);
        throw new Error(str + " does not have matching emoji definition");
      }

      return "<span class=\"icon " + emoji.iconClass + "\"></span>";
    });
  }

  var businessReg = /(business_)\d{1}/g;

  if (businessReg.test(msg)) {
    return "<span class=\"icon " + BIZ_EMOJI_PREFIX + msg + "\"></span>";
  }

  return msg;
}